import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Calculator from "../../components/Frontend/Calculator";
import LoginComp from "../../components/Frontend/LoginComp";
import Plans from "../../components/Frontend/Plans";
import Testimonials from "../../components/Frontend/Testimonials";
import Preloader from "../../components/Preloader";
import HomePageLayout from "../../layouts/HomepageLayout";
import "../../styles/Frontend/components.scss";
import "../../styles/Frontend/index.scss";
import "../../styles/Frontend/pages.scss";

const Homepage = () => {
  const [visible, setVisible] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showCalc, setShowCalc] = useState(false);
  const [loader, setLoader] = useState(true);
  const [authBtn, setAuthBtn] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoader(false), 2000);
  }, []);

  useEffect(() => {
    const isLoggedIn = async () => {
      let token = localStorage.getItem("auth-token");
      if (token !== "") {
        setAuthBtn(true);
      }
    };

    isLoggedIn();
  }, []);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 400) {
      setVisible(true);
    } else if (scrolled <= 400) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  window.addEventListener("scroll", toggleVisible);
  return (
    <>
      {loader ? (
        <Preloader />
      ) : (
        <HomePageLayout>
          <div className="app">
            <header>
              <img className="btc-gif" src="/imgs/btc2.gif" alt="" />
              <main>
                <h1>
                  TAKE YOUR <span>INVESTMENT STRATEGY</span>
                </h1>
                <h1>
                  TO THE <span>NEXT LEVEL</span>
                </h1>
                <p>
                  Your guide to securing a financial future in the Tech
                  industry.
                </p>

                <div className="banner-btns d-flex">
                  {authBtn ? (
                    <div>
                      <Link to="/dashboard">
                        <button className="btn mx-3 ">
                          <span> GO TO DASHBOARD </span>
                        </button>
                      </Link>
                    </div>
                  ) : (
                    <div>
                      <Link to="/register">
                        <button className="btn mx-3 ">
                          <span> GET STARTED NOW</span>
                        </button>
                      </Link>
                      <button
                        className="mx-3 btn"
                        onClick={() => {
                          // setNavOpen(!navOpen);
                          setShowLogin(!showLogin);
                        }}
                      >
                        SIGN IN
                      </button>
                    </div>
                  )}

                  <button
                    className="mx-3 btn btn-outline calculator-button"
                    onClick={() => {
                      // setNavOpen(!navOpen);
                      setShowCalc(!showCalc);
                    }}
                  >
                    Profit Calculator
                  </button>
                </div>
              </main>
              <iframe
                title="taperwidget"
                scrolling="no"
                allowtransparency="true"
                frameBorder="0"
                src="https://s.tradingview.com/embed-widget/ticker-tape/?locale=en#%7B%22symbols%22%3A%5B%7B%22proName%22%3A%22FOREXCOM%3ASPXUSD%22%2C%22title%22%3A%22S%26P%20500%22%7D%2C%7B%22proName%22%3A%22FOREXCOM%3ANSXUSD%22%2C%22title%22%3A%22Nasdaq%20100%22%7D%2C%7B%22proName%22%3A%22FX_IDC%3AEURUSD%22%2C%22title%22%3A%22EUR%2FUSD%22%7D%2C%7B%22proName%22%3A%22BITSTAMP%3ABTCUSD%22%2C%22title%22%3A%22BTC%2FUSD%22%7D%2C%7B%22proName%22%3A%22BITSTAMP%3AETHUSD%22%2C%22title%22%3A%22ETH%2FUSD%22%7D%5D%2C%22showSymbolLogo%22%3Atrue%2C%22colorTheme%22%3A%22dark%22%2C%22isTransparent%22%3Afalse%2C%22displayMode%22%3A%22adaptive%22%2C%22width%22%3A%22100%25%22%2C%22height%22%3A78%2C%22utm_source%22%3A%22www.tradingview.com%22%2C%22utm_medium%22%3A%22widget_new%22%2C%22utm_campaign%22%3A%22ticker-tape%22%7D"
                style={{
                  boxSizing: "border-box",
                  height: "50px",
                  width: "100%",
                }}
              ></iframe>
            </header>

            <section className="about">
              <div className="container inner">
                <div className="about-text">
                  <h2 className="fw-bold text-primary">
                    WELCOME TO{" "}
                    <span className="bg-primary text-dark px-3">KUXTECH</span>
                  </h2>
                  <p className="text-light">
                    Kuxtech is a fund company based in the United States of
                    America that sees into the future in the tech industry and
                    primarily aim at providing our customers financial assets
                    across diverse leading prospects booming in the financial
                    markets of the technology industry. Kuxtech is a vision
                    driven financial tech company incorporated on the 13th of
                    October 2004 growing with satisfied customers throughout the
                    years. We are registered under the Securities Act of 1933
                    and the Investment Company Act of 1940, The Internet
                    Corporation for Assigned Names and Numbers ICANN, and
                    regulated by the Securities and Exchange Commission (SEC)
                    under the Investment Company Act of 1940.
                  </p>
                  <ul className="mt-3">
                    <li>
                      <i className="fas fa-users"></i>
                      <h1>568k</h1>
                      <p>CLIENTS</p>
                    </li>
                    <li>
                      <i className="fas fa-copy"></i>
                      <h1>457</h1>
                      <p>SERVERS</p>
                    </li>
                    <li>
                      <i className="fas fa-edit"></i>
                      <h1>102</h1>
                      <p>ADVISORS</p>
                    </li>
                    <li>
                      <i className="fas fa-clock"></i>
                      <h1>19</h1>
                      <p>YEARS</p>
                    </li>
                  </ul>

                  <div className="about-button">
                    <Link to="/register">
                      <button className="btn mt-3 ">GET STARTED NOW</button>
                    </Link>
                  </div>
                </div>
                <div className="about-img">
                  <img src="/imgs/asset10.jpeg" alt="" />
                  <div className="about-ceo">
                    <h5>Victor Dean</h5>
                    <p>CEO Kuxtech</p>
                    <small>
                      Victor Dean is a leading global influencer in stock,
                      options and forex trading.
                    </small>
                  </div>
                </div>
              </div>
            </section>

            <section className="plans">
              <div className="container inner">
                <div className="section-title">
                  <h1 className="fw-bold">INVESTMENT PLANS</h1>
                  <p>
                    To make a solid investment, you have to know where you are
                    investing. Find a plan which is best for you.
                  </p>
                </div>

                <Plans />
              </div>
            </section>

            <section className="features">
              <div className="container inner">
                <div className="section-title">
                  <h1 className="fw-bold">OUR AMAZING FEATURES</h1>
                  <p className="text-center w-75">
                    Our goal is to provide our investors with a reliable source
                    of high income, while minimizing any possible risks and
                    offering a high-quality service.
                  </p>
                </div>

                <div className="features-wrapper">
                  <div className="feature">
                    <i className="fas fa-file-contract"></i>
                    <h6>Legal Company</h6>
                    <p>
                      Our company conducts absolutely legal activities in the
                      legal field. We are certified to operate investment
                      business, we are legal and safe.
                    </p>
                  </div>
                  <div className="feature">
                    <i className="fa fa-handshake"></i>
                    <h6>Insured</h6>
                    <p>
                      Our Trading program is insured with about $489M. This
                      covers for 80% of your trading risk. Access your earnings
                      and request withdrawals without a hitch.
                    </p>
                  </div>
                  <div className="feature">
                    <i className="fas fa-bezier-curve"></i>
                    <h6>Multi-Vector Company</h6>
                    <p>
                      The multidirectionality of the applied efforts determines
                      the high profitability of the investment placement process
                      in our company.
                    </p>
                  </div>
                  <div className="feature">
                    <i className="fa fa-lock"></i>
                    <h6>Highly Secure</h6>
                    <p>
                      As a platform you can trust, we're built with multiple
                      layers of security including the latest encryption
                      standards for even thicker walls of security.
                    </p>
                  </div>
                  <div className="feature">
                    <i className="fas fa-cloud"></i>
                    <h6>Cloud Mining </h6>
                    <p>
                      We have set up remote mining rigs for our clients, simply
                      select a plan that best fits your financial capabilities
                      and mine various crypto currencies on the go.
                    </p>
                  </div>
                  <div className="feature">
                    <i className="fas fa-receipt"></i>
                    <h6>No Hidden Fees</h6>
                    <p>
                      Unlimited withdrawals or deposits included. You’ll never
                      be surprised by additional fees on your statement.
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="profit-calculator">
              <div className="container inner">
                <div className="profit-calc-text">
                  <h3 className="fw-bold text-light">
                    Perform a calculation of your possible profits from{" "}
                    <span className="bg-primary text-dark px-3">KUXTECH</span>
                  </h3>
                  <p className="text-light my-4">
                    Use the calculator to see how much profits you make with
                    each investment plan. You should know the calculation before
                    investing in any plan, so you make the best investments.
                  </p>
                </div>

                <Calculator />
              </div>
            </section>

            <section className="crypto-market">
              <div className="container inner">
                <div className="section-title">
                  <h1 className="fw-bold">CRYPTOCURRENCY MARKET</h1>
                  <p className="text-center w-75">
                    Stay up to date with the key metrics of the crypto market
                    such as closing price, total and available number of coins,
                    traded volume and price change percentage are all available
                    at a quick glance.
                  </p>
                </div>

                <iframe
                  className="mt-5"
                  title="crypto"
                  src="https://widget.coinlib.io/widget?type=full_v2&theme=dark&cnt=15&pref_coin_id=1505&graph=yes"
                  width="100%"
                  height="790px"
                  scrolling="auto"
                  marginWidth="0"
                  marginHeight="0"
                  frameBorder="0"
                  border="0"
                  style={{
                    border: "0",
                    margin: "0",
                    padding: "0",
                    height: "81.5vh",
                  }}
                ></iframe>
              </div>
            </section>

            <section className="testimonials">
              <div className="container inner">
                <div className="section-title">
                  <h1 className="fw-bold">TESTIMONIALS</h1>
                  <p>What Our Clients Say About Us.</p>
                </div>

                <Testimonials />
              </div>
            </section>

            <div
              className={`scroll-to-top ${visible ? "show-stt" : ""}`}
              onClick={scrollToTop}
            >
              <div className="manual-tooltip">
                <i className="fas fa-arrow-up"></i>
                <span className="tooltiptext">Scroll To Top</span>
              </div>
            </div>

            <div
              className={`modal-component ${showLogin ? "modal-visible" : ""}`}
            >
              <div className="inner">
                <i
                  className="far fa-times-circle close"
                  onClick={() => {
                    setShowLogin(!showLogin);
                  }}
                ></i>
                <LoginComp />
                <label className="no-account">
                  Don't have an account?{" "}
                  <Link to="register">
                    <span
                      onClick={() => {
                        setShowLogin(!showLogin);
                      }}
                    >
                      SIGN UP
                    </span>
                  </Link>
                </label>
              </div>
            </div>

            <div
              className={`modal-component ${showCalc ? "modal-visible" : ""}`}
            >
              <div className="inner calc">
                <i
                  className="far fa-times-circle close"
                  onClick={() => {
                    setShowCalc(!showCalc);
                  }}
                ></i>
                <Calculator />
              </div>
            </div>
          </div>
        </HomePageLayout>
      )}
    </>
  );
};

export default Homepage;
